// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__7u7bm","rootSuccess":"CompleteLink_rootSuccess__UKLuV","rootFailure":"CompleteLink_rootFailure__MVwkn","isDisabled":"CompleteLink_isDisabled__2iMbs"};